import CountUp from "react-countup";
import DødePlotMini from "./DødePlotMini";

const easeDuration = 2; // seconds

function Døde({ døde }) {
	const dødeSenest = døde.sort((a, b) => b.date - a.date)[0]

	return (
		<div>
			<h1>Døde</h1>
			<div className="numberCircle" style={{ backgroundColor: "black", transition: `background-color ${easeDuration}s ease-out` }}>
				<CountUp end={dødeSenest.newDeaths} decimals={0} duration={easeDuration} />
				<div className="circleDate">
					<small>{dødeSenest.date.toISOString().substring(0, 10)}</small>
				</div>
			</div>
			<DødePlotMini døde={døde} />
		</div>
	)
}

export default Døde